import { render } from "./TokenDialog.vue?vue&type=template&id=492ee622"
import script from "./TokenDialog.vue?vue&type=script&lang=js"
export * from "./TokenDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__